
import { makeRequest } from "../lib/makeRequest";


export const inventory_target_overall = (data) =>
  makeRequest("/target-inventories/overall", {
    from_month: data.from_month,
    from_year: data.from_year,
    to_month: data.to_month,
    to_year: data.to_year
  });

export const inventory_target_cluster = (data) =>
  makeRequest(`/target-inventories/cluster/${data.clusterId}`, {
    from_month: data.from_month,
    from_year: data.from_year,
    to_month: data.to_month,
    to_year: data.to_year
  });

export const inventory_target_area = (data) =>
  makeRequest(`/target-inventories/area/${data.areaId}`, {
    from_month: data.from_month,
    from_year: data.from_year,
    to_month: data.to_month,
    to_year: data.to_year
  });

export const inventory_target_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from_month", data.from_month);
  urlParams.append("from_year", data.from_year);
  urlParams.append("to_month", data.to_month);
  urlParams.append("to_year", data.to_year);
  return makeRequest(`/target-inventories/branches?${urlParams.toString()}`, data.branch_codes, 'post');
};